import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Heading, Stack, Text } from "@chakra-ui/react";

const UserDetails = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("userEmail");
  const password = localStorage.getItem("userPassword");

  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userPassword");
    navigate("/");
  };

  return (
    <Stack spacing={8} w={{ base: "90%", md: "40%" }} m={"auto"} py={12} px={6}>
      <Text fontSize="4xl">
        Email: <Heading>{email}</Heading>{" "}
      </Text>

      <Text fontSize="4xl">
        Password:<Heading>{password}</Heading>{" "}
      </Text>

      <Button onClick={handleLogout} w={{ base: "50%", md: "50%" }}>
        Logout
      </Button>
    </Stack>
  );
};

export default UserDetails;
